export default "__VITE_ASSET__C7EcTqkw__"